import {Component} from '@angular/core';
import {PilePoilsTranslatePipe} from '@shared/pipes/pilepoils-translate.pipe';

@Component({
  templateUrl: './privacy-policy.component.html',
  imports: [
    PilePoilsTranslatePipe
  ],
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
}
